export default __webpack_public_path__ + "static/media/edit-reservation.10a7b0cc.svg";